module.exports = __webpack_public_path__ + "img/Edge Lab.9da2d673.svg";